import { render } from "./UiAdressenTr.pug?vue&type=template&id=590b05b3&lang=pug"
import script from "./UiAdressenTr.js?vue&type=script&lang=js"
export * from "./UiAdressenTr.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__